import Axios from 'axios';

const API_URL = process.env.API_URL + '/api/v1/';

class JenisBank {
    index() {
        return Axios.get(API_URL + 'jenisbank-list?order_column=name&order_direction=asc');
    }

    show(id) {
        return Axios.get(API_URL + `jenisbank/${id}`);
    }
}

export default new JenisBank();



// WEBPACK FOOTER //
// ./src/api/jenisbank.js